import React from 'react';
import { FaFacebookF, FaWhatsapp, FaLinkedin } from 'react-icons/fa';
import { FaLinkSlash } from 'react-icons/fa6';
const ProductShareComponents: React.FC<any> = ({ shareProduct, item_code }) => {
  return (
    <>
      <div className='flex items-center gap-3'>
        <h3 className='text-sm sm:text-sm md:text-base lg:text-base text-black whitespace-nowrap font-poppins'>
          Share items:
        </h3>
        <div className='flex items-center gap-2'>
          <div
            onClick={() => shareProduct.whatsApp(item_code)}
            className='p-2 bg-white rounded-full cursor-pointer hover:bg-[#552B18] group'
          >
            <FaWhatsapp className='w-5 h-5 sm:w-6 sm:h-6 text-gray-600 group-hover:text-white' />
          </div>
          <div
            onClick={() => shareProduct.facebook(item_code)}
            className='p-2 bg-white rounded-full cursor-pointer hover:bg-[#552B18] group'
          >
            <FaFacebookF className='w-5 h-5 sm:w-6 sm:h-6 text-gray-600 group-hover:text-white' />
          </div>
          <div
            onClick={() => shareProduct.linkedin(item_code)}
            className='p-2 bg-white rounded-full cursor-pointer hover:bg-[#552B18] group'
          >
            <FaLinkedin className='w-5 h-5 sm:w-6 sm:h-6 text-gray-600 group-hover:text-white' />
          </div>
          <div
            onClick={() => shareProduct.copyLink(item_code)}
            className='p-2 bg-white rounded-full cursor-pointer hover:bg-[#552B18] group'
          >
            <FaLinkSlash className='w-5 h-5 sm:w-6 sm:h-6 text-gray-600 group-hover:text-white' />
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductShareComponents;
